export interface IConfig {
  clientId: string;
  clientSecret: string;
  domain: string;
  endPoint?: string;
}
